import { render, staticRenderFns } from "./roleManageDetail.vue?vue&type=template&id=bc5c5776&scoped=true"
import script from "./roleManageDetail.vue?vue&type=script&lang=js"
export * from "./roleManageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5c5776",
  null
  
)

export default component.exports